import { supabase } from '../supabaseClient'

export default function SuspendedScreen({ reason }) {
  const handleSignOut = async () => {
    await supabase.auth.signOut()
    window.location.href = '/login'
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      background: 'rgba(15, 23, 42, 0.96)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
      padding: '24px',
    }}>
      <div style={{
        background: 'white', borderRadius: '20px', padding: '48px 40px',
        width: '100%', maxWidth: '480px', textAlign: 'center',
        boxShadow: '0 32px 80px rgba(0,0,0,0.4)',
      }}>
        {/* Icon */}
        <div style={{
          width: '64px', height: '64px', borderRadius: '16px',
          background: '#FFF1F2', border: '1px solid #FECDD3',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px', fontSize: '28px',
        }}>🔒</div>

        <h1 style={{
          fontSize: '22px', fontWeight: '800', color: '#0F172A',
          margin: '0 0 12px', letterSpacing: '-0.4px',
        }}>Account Suspended</h1>

        <p style={{
          fontSize: '14px', color: '#64748B', margin: '0 0 24px',
          lineHeight: '1.6',
        }}>
          Your account has been temporarily suspended. You cannot access your dashboard at this time.
        </p>

        {reason && (
          <div style={{
            background: '#FFFBEB', border: '1px solid #FDE68A',
            borderRadius: '10px', padding: '14px 16px', marginBottom: '24px',
            textAlign: 'left',
          }}>
            <p style={{ fontSize: '12px', fontWeight: '600', color: '#D97706', margin: '0 0 4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Reason</p>
            <p style={{ fontSize: '13px', color: '#92400E', margin: 0 }}>{reason}</p>
          </div>
        )}

        <div style={{
          background: '#F8FAFC', borderRadius: '10px', padding: '16px',
          marginBottom: '28px',
        }}>
          <p style={{ fontSize: '13px', color: '#374151', margin: '0 0 6px', fontWeight: '600' }}>
            Need help?
          </p>
          <p style={{ fontSize: '13px', color: '#64748B', margin: 0 }}>
            Please contact support to resolve this issue and reactivate your account.
          </p>
        </div>

        <a href="mailto:support@quoteflow.app" style={{
          display: 'block', width: '100%', height: '44px', borderRadius: '10px',
          background: 'linear-gradient(135deg, #2563EB, #1D4ED8)',
          color: 'white', fontSize: '14px', fontWeight: '700',
          border: 'none', cursor: 'pointer', textDecoration: 'none',
          lineHeight: '44px', marginBottom: '12px', boxSizing: 'border-box',
        }}>Contact Support</a>

        <button onClick={handleSignOut} style={{
          width: '100%', height: '44px', borderRadius: '10px',
          background: 'white', border: '1.5px solid #E2E8F0',
          fontSize: '14px', fontWeight: '600', color: '#64748B', cursor: 'pointer',
        }}>Sign Out</button>
      </div>
    </div>
  )
}